import * as yup from "yup";

const CEASchema = yup.object({
  ceaCabinOutsidePhoto: yup.string(),
  ceaOutsideGutterSidePhoto: yup.string(),
  ceaOutsideNonGutterSidePhoto: yup.string(),
  ceaGutterSidePhoto: yup.string(),
  ceaNonGutterSidePhoto: yup.string(),
  ceaSide1VentHandlePhoto: yup.string(),
  ceaSide2VentHandlePhoto: yup.string(),
  ceaSide3VentHandlePhoto: yup.string(),
  ceaSide4VentHandlePhoto: yup.string(),
  ceaShadeNetClosedPhoto: yup.string(),
  ceaShadeNetOpenPhoto: yup.string(),
  ceaWeedmatPhoto: yup.string(),
  ceaAcfPhoto: yup.string(),
});

const FoggerSchema = yup.object({
  foggerTankPhoto: yup.string(),
  foggerMotorPhoto: yup.string(),
  foggerDiskFilterPhoto: yup.string(),
  foggerTakeOffPhoto: yup.string(),
  foggerOnStatePhoto: yup.string(),
  foggerTimerPhoto: yup.string(),
});

const FlatbedSchema = yup.object({
  flatbedPipesPhoto: yup.string(),
  flatbedFramePhoto: yup.string(),
  flatbedWaterTankPhoto: yup.string(),
  flatbedWaterTankInletValvePhoto: yup.string(),
  flatbedWaterPumpPhoto: yup.string(),
  flatbedWaterRecollectionPipePhoto: yup.string(),
  flatbedNetcupPhoto: yup.string(),
  flatbedWaterFlowFromRoPipePhoto: yup.string(),
  flatbedTimerPhoto: yup.string(),
});

const GrowbagsSchema = yup.object({
  growbagsTankPhoto: yup.string(),
  growbagsMotorPhoto: yup.string(),
  growbagsDiskFilterPhoto: yup.string(),
  growbagsTakeOffPhoto: yup.string(),
  growbagsOnStatePhoto: yup.string(),
  growbagsArrowDripperPhoto: yup.string(),
  growbagsDripPipeEndPhoto: yup.string(),
  growbagsTimerPhoto: yup.string(),
  growbagTrellisingPhoto: yup.string(),
  growbagJHookPhoto: yup.string(),
});

export const ClientProjectHandoverSchema = yup.object().shape({
  projectId: yup.number().required("Required"),
  handOverDate: yup.date(),
  siteSelectionId: yup.number().required("Required"),

  generatedBy: yup.string(),

  // --- CEA ---------

  ceaCabinOutsidePhoto: yup.string(),
  ceaOutsideGutterSidePhoto: yup.string(),
  ceaOutsideNonGutterSidePhoto: yup.string(),
  ceaGutterSidePhoto: yup.string(),
  ceaNonGutterSidePhoto: yup.string(),
  ceaSide1VentHandlePhoto: yup.string(),
  ceaSide2VentHandlePhoto: yup.string(),
  ceaSide3VentHandlePhoto: yup.string(),
  ceaSide4VentHandlePhoto: yup.string(),
  ceaShadeNetClosedPhoto: yup.string(),
  ceaShadeNetOpenPhoto: yup.string(),
  ceaWeedmatPhoto: yup.string(),
  ceaAcfPhoto: yup.string(),

  //----Fogger----

  foggerTankPhoto: yup.string(),
  foggerMotorPhoto: yup.string(),
  foggerDiskFilterPhoto: yup.string(),
  foggerTakeOffPhoto: yup.string(),
  foggerOnStatePhoto: yup.string(),
  foggerTimerPhoto: yup.string(),

  //------Flatbed----

  flatbedPipesPhoto: yup.string(),
  flatbedFramePhoto: yup.string(),
  flatbedWaterTankPhoto: yup.string(),
  flatbedWaterTankInletValvePhoto: yup.string(),
  flatbedWaterPumpPhoto: yup.string(),
  flatbedWaterRecollectionPipePhoto: yup.string(),
  flatbedNetcupPhoto: yup.string(),
  flatbedWaterFlowFromRoPipePhoto: yup.string(),
  flatbedTimerPhoto: yup.string(),

  //---------Growbag

  growbagsTankPhoto: yup.string(),
  growbagsMotorPhoto: yup.string(),
  growbagsDiskFilterPhoto: yup.string(),
  growbagsTakeOffPhoto: yup.string(),
  growbagsOnStatePhoto: yup.string(),
  growbagsArrowDripperPhoto: yup.string(),
  growbagsDripPipeEndPhoto: yup.string(),
  growbagsTimerPhoto: yup.string(),
  growbagTrellisingPhoto: yup.string(),
  growbagJHookPhoto: yup.string(),

  //----Upload Viedos--

  ceaOutsideAssemblyVideo: yup.string(),
  sideVentOperatingVideo: yup.string(),
  enteringInsideCeaVideo: yup.string(),
  flatbedEntireAssemblyVideo: yup.string(),
  growbagsEntireAssemblyVideo: yup.string(),

  northSouthMeasurmentInMeter: yup.string(),
  northSouthMeasurmentPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  eastWestMeasurmentInMeter: yup.string(),
  eastWestMeasurmentPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  handOverCertificate: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  descriptionVideo: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  notes: yup.string(),
  overheadTankPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  aFramePhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  netCupPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  aFrameFoundationPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  ventOpenerPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  aluminiumShadeNetPullyPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  exhaustFanPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  cellusePadPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  waterPumpPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  waterPumpDrainagePhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  oxigenationPumpPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  uvLightPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  diskFilterPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  sandFilterPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  foggerAssemblyPhoto: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  customerPhotoWithSetUp: yup.mixed().test(
    "is-valid-size",
    "Max allowed size is 10MB",
    (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    } // Ensure value exists and size is valid
  ),
  customerFeedbackVideo: yup.string(),
  // Ensure value exists and size is valid
});
